import { TokenModal, DataModal } from "../../helpers/common/EditModels";
import { ServiceUrlHelper } from "../../helpers/ServiceUrlHelper";
import { EndPoint, Environment } from "../../util";
import { getAccessToken } from "../../auth/msal";
import { ErrorCodes, HTTPMethods } from "../../util/UIConstants";
import { APIMiddleware } from "../../helpers/api-middleware";
import isEmpty from "lodash/isEmpty";

export class UniversalService {
  public static async getUserPreferenceAsync(): Promise<DataModal> {
    const modal: DataModal = new DataModal();

    const universalAccessToken: TokenModal = await this.getUniversalAccessTokenAsync();

    if (universalAccessToken.ErrorCode) {
      modal.ErrorCode = universalAccessToken.ErrorCode;

      return modal;
    }

    const userJsonUri = ServiceUrlHelper.getUniversalUserPreferenceEndpoint();

    const userresponse = await APIMiddleware.fetch(
      HTTPMethods.Get,
      userJsonUri,
      universalAccessToken.AccessToken,
      null
    );

    modal.response = userresponse;

    if (!userresponse.apiResponseReturned) {
      modal.ErrorCode = ErrorCodes.UniversalApiNoResponseError;
      return modal;
    }

    if (userresponse.apiResponseReturned && userresponse.errorCode) {
      modal.ErrorCode = userresponse.errorCode;
      return modal;
    }

    return modal;
  }

  public static async getUniversalAccessTokenAsync(): Promise<TokenModal> {
    const tokenModal: TokenModal = new TokenModal();

    const endpoint = Environment.getUniversalApiEndpoint();

    const universalAccessToken = await getAccessToken({ audience: endpoint.audience, url: endpoint.serviceUrl });

    if (!universalAccessToken) {
      tokenModal.ErrorCode = ErrorCodes.AccessTokenGetError;
    }

    tokenModal.AccessToken = universalAccessToken;

    return tokenModal;
  }

  public static async getHerculesApiBaseUriAsync(engagementId: string): Promise<EndPoint> {
    const endpointName = `${ServiceUrlHelper.herculesEndPointNamePrefix}-${engagementId}`;

    let herculesEndPointInfo: EndPoint = Environment.findCachedEndPoint(endpointName) || {
      name: endpointName,
      serviceUrl: "",
      audienceUrl: "",
      isldcupgraded: false,
      datacenterversion: "",
      isError: false,
      ErrorCode: ErrorCodes.NoError,
    };

    if (herculesEndPointInfo && herculesEndPointInfo.ErrorCode) {
      herculesEndPointInfo.ErrorCode = ErrorCodes.NoError;
    }

    if (!Environment.isValidEndPoint(herculesEndPointInfo)) {
      let universalAccessToken = await this.getUniversalAccessTokenAsync();

      if (isEmpty(universalAccessToken.AccessToken)) {
        herculesEndPointInfo.ErrorCode = universalAccessToken.ErrorCode;
        return herculesEndPointInfo;
      }

      let homeJsonUri = ServiceUrlHelper.getUniversalAppHomeEndpoint(engagementId);

      let response = await APIMiddleware.fetch("GET", homeJsonUri, universalAccessToken.AccessToken, null);

      if (!response.apiResponseReturned) {
        herculesEndPointInfo.ErrorCode = ErrorCodes.UniversalApiNoResponseError;
        return herculesEndPointInfo;
      }

      if (response.apiResponseReturned && response.errorCode) {
        herculesEndPointInfo.ErrorCode = response.errorCode;
        return herculesEndPointInfo;
      }

      var data = response.data;

      herculesEndPointInfo = ServiceUrlHelper.getHerculesEndPointUri(data);

      if (Environment.isValidEndPoint(herculesEndPointInfo)) {
        Environment.addEndPointToCache(herculesEndPointInfo);
        console.log("hercules endpoint cached", herculesEndPointInfo);
      }
    }

    return herculesEndPointInfo;
  }

  public static async getUserAccessibleEngagement(): Promise<DataModal> {
    let modal: DataModal = new DataModal();

    const universalAccessToken: TokenModal = await this.getUniversalAccessTokenAsync();

    if (universalAccessToken.ErrorCode) {
      modal.ErrorCode = universalAccessToken.ErrorCode;
      return modal;
    }

    const settings = Environment.getSettings();

    let restrictedDatacenterIds = settings.RestrictedDatacenterIds.split(",").map(Number);

    let userJsonUri = ServiceUrlHelper.getUniversalUserEngagementEndpoint();

    let userresponse = await APIMiddleware.fetch(HTTPMethods.Get, userJsonUri, universalAccessToken.AccessToken, null);

    if (!isEmpty(restrictedDatacenterIds)) {
      if (userresponse?.data?.engagementmetadatadetails) {
        userresponse.data.engagementmetadatadetails = userresponse.data.engagementmetadatadetails.filter((item) => {
          if (!restrictedDatacenterIds.includes(item.datacenterid)) {
            return item;
          }
        });
      }
    }
    modal.response = userresponse;
    if (!userresponse.apiResponseReturned) {
      modal.ErrorCode = ErrorCodes.UniversalApiNoResponseError;
      return modal;
    }

    if (userresponse.apiResponseReturned && userresponse.errorCode) {
      modal.ErrorCode = userresponse.errorCode;
    }

    return modal;
  }
}
